module.exports = __webpack_public_path__ + "img/cart-buy.82f03ba7.png";